<h1>AI Answers</h1>
<p class="disclaimer">
  This is a Semeris AI experiment. Avoid sharing sensitive information. <a [routerLink]="['/', 'help', 'ai-answers.html']">Learn more</a>
</p>
<div #commentScrollArea class="comment-scroll-area">
  @if (!conversationId) {
    <semeris-comment-input
      #commentInput
      [autofocus]="true"
      (send)="onSend($event)"
      placeholder="Ask me about features or datapoints..."
      maxLengthWarning="You are reaching the maximum possible length of a question."
      maxLengthError="You have been reached the maximum possible length of a question."
    >
    </semeris-comment-input>
  }
  <semeris-comment-thread
    class="ai-thread"
    [editable]="false"
    [comments]="comments$ | async"
    [loading]="thinking$ | async"
  ></semeris-comment-thread>
  @if ((comments$ | async)?.length > 1 && !(thinking$ | async)) {
    <div class="thread-feedback">
      <semeris-comment-customer-feedback [conversationId]="conversationId"></semeris-comment-customer-feedback>
    </div>
    <div class="thread-controls">
      <button class="restart-button" semerisButton color="accent" (click)="onAnotherQuestion()">I have another question</button>
      <button (click)="onContactSupport()" semerisButton variant="outline" color="accent">Contact Support</button>
    </div>
  }
</div>

